module.exports = __webpack_public_path__ + "media/images/emblems/Givisiez-coat_of_arms-d4e9f05a0fafbf46bb319f299a23a8e0.svg";